import Reveal from '@/components/base/Reveal';
import { aboutHighlights, aboutStory, aboutStoryImage } from '@/mocks/aboutData';
import { stats } from '@/mocks/homeData';

export default function AboutStory() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <div className="w-full">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
                <span className="w-6 h-px bg-primary-500"></span>
                Our Story
              </span>
              <h2 className="font-heading mt-3 text-2xl md:text-4xl font-semibold leading-tight text-foreground-950">
                Authentic Ayurveda, Crafted With Care in Madurai
              </h2>

              <div className="mt-5 space-y-4">
                {aboutStory.map((paragraph) => (
                  <p key={paragraph.slice(0, 24)} className="text-sm md:text-base leading-relaxed text-foreground-600">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="mt-7 grid grid-cols-2 gap-3">
                {aboutHighlights.map((item) => (
                  <div
                    key={item.id}
                    className="flex items-center gap-3 p-3 rounded-lg border border-background-200 bg-background-100/70"
                  >
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <span className="text-xs md:text-sm font-semibold text-foreground-800">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="w-full rounded-2xl overflow-hidden border border-background-200 bg-background-100">
              <img
                src={aboutStoryImage}
                alt="Herbal Ayurvedic medicine production process at Best Research Pharma"
                title="Best Research Pharma - Ayurvedic medicine manufacturing"
                className="w-full h-[320px] md:h-[460px] object-cover object-top"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((item) => (
            <Reveal key={item.id}>
              <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 text-center">
                <p className="font-heading text-3xl md:text-4xl font-semibold text-primary-700">{item.value}</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}